import { Injectable } from '@angular/core';
import { GenericRoteirizadorService } from '../../../core/services/generic-roteirizador.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import {PracaModel} from '../models/praca.model';

@Injectable({ providedIn: 'root' })
export class PracaService extends GenericRoteirizadorService {

  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/pracas';
  }

  listar() {
    return this.get<any[]>('/listar');
  }

  consultarPorIds(ids: string[]) {
    return this.post<PracaModel[]>('/consultarPorIds', { dados: ids });
  }

  consultarListaDePracas(dados) {
    return this.post<PracaModel[]>('/consultarListaDePracas', {dados});
  }


  listarPracasByIds(filtro: any) {
    return this.post<any[]>('/listarPracasByIds', { dados: filtro });
  }

}
